import React from 'react';
import { Button, Result } from 'antd';
import api from '../services/api';

// §111 — Replaces the React "white screen" with a recoverable message and reports the
// crash to the backend (POST /api/v1/client-errors → Cloud Logging) so it can be diagnosed.
interface State {
  hasError: boolean;
}

export default class AppErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    api.post('/api/v1/client-errors', {
      message: String(error?.message ?? error).slice(0, 1000),
      stack: String(error?.stack ?? '').slice(0, 4000),
      component_stack: String(info?.componentStack ?? '').slice(0, 4000),
      path: window.location.pathname,
    }).catch(() => {
      // best effort — never let reporting break the fallback screen
    });
  }

  render(): React.ReactNode {
    if (!this.state.hasError) return this.props.children;
    return (
      <Result
        status="error"
        title="Une erreur est survenue"
        subTitle="L'erreur a été signalée automatiquement. Rechargez la page pour continuer."
        extra={<Button type="primary" onClick={() => window.location.reload()}>Recharger</Button>}
      />
    );
  }
}
